import Vue from "vue";
import ThumbhashImage from "@/components/ThumbhashImage.vue";

Vue.component("ThumbhashImage", ThumbhashImage);
